import React from 'react'
import PropTypes from 'prop-types'
import { CardTable, SORT } from 'common/components/datatable/Table'
import { darkBlue } from 'app/theme'
import { ExportAction } from 'common/utils/ExportUtils'

export const VersionsTable = ({ title, rows, status, onRowClick, headers, postReleaseBugCount, onShowPostReleaseBugs }) => {
    const onExport = () => {
        ExportAction.exportData(
            [
                ['Id', 'Projet', 'Produit', 'Résumé', 'Fonctionnalité (balises)', 'Rapporteur', 'Affecté à', 'Date de soumission', 'Changelog'].map(h => ({ value: h })),
                ...rows.map(r => ([
                    { value: `${r.id ?? ''}` },
                    { value: `${r?.project?.value ?? ''}` },
                    { value: `${r?.product?.value ?? ''}` },
                    { value: `${r?.summary?.sortValue ?? ''}` },
                    { value: `${r?.balises?.value ?? ''}` },
                    { value: `${r?.reporter?.value ?? ''}` },
                    { value: `${r?.handler?.value ?? ''}` },
                    { value: `${r?.dateSubmitted?.value ?? ''}` },
                    { value: `${r?.changeLog?.sortValue ?? ''}` },
                ])),
            ],
            title,
        )
    }

    return (
        <CardTable
            title={title}
            actions={[{
                icon: 'bug_report',
                tooltip: `Bugs critiques post-release${Number.isFinite(postReleaseBugCount) ? ` (${postReleaseBugCount})` : ''}`,
                onClick: onShowPostReleaseBugs,
                color: 'white',
                displayed: postReleaseBugCount !== undefined,
            }, {
                icon: 'download',
                tooltip: 'Exporter',
                onClick: onExport,
                color: 'white',
            }]}
            color={darkBlue}
            headers={headers}
            rows={rows}
            status={status}
            rowsPerPageDefault={25}
            defaultSort={{ column: 'submittedAt', direction: SORT.DESC }}
            onClickRow={onRowClick}
        />
    )
}

VersionsTable.propTypes = {
    title: PropTypes.string,
    rows: PropTypes.array,
    status: PropTypes.string,
    onExport: PropTypes.func,
    onRowClick: PropTypes.func,
    headers: PropTypes.array.isRequired,
    postReleaseBugCount: PropTypes.number,
    onShowPostReleaseBugs: PropTypes.func,
}
